<template>
  <li :class="{ active: isActive }">
    <a ref="link" href="#" :class="{ active: isChildActive }" :aria-expanded="isActive ? 'true' : 'false'" @click.prevent="toggle">
      <span v-html="name" />
      <span v-if="isChildActive" class="sr-only">{{ $t('common.currently_active') }}</span>
    </a>
    <transition name="navi" appear>
      <div v-if="isActive" class="brandnav brandnav-lvl-2" style="max-height: 1142px">
        <div class="brandnav-lvl-2-head">
          <button type="button" class="cancel" @click="toggleOff">
            <span class="sr-only">{{ $t('common.close') }}</span>
            <VSvgIcon name="cancel" variant="outlined" />
          </button>
        </div>
        <div class="cu-block-menu_sitemap_pages">
          <div class="cu-megamenu">
            <div class="container-fixed cu-megamenu__container-fixed">
              <ul class="cu-megamenu__list">
                <slot />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </li>
</template>

<script>
import { metas } from '@/utils/navigation';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'NavigationMenu',
  components: { VSvgIcon },

  props: {
    name: {
      type: String,
      required: true,
    },

    group: {
      type: String,
      required: true,
    },

    expanded: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    isActive() {
      return this.name === this.expanded;
    },

    isChildActive() {
      return this.group === metas[this.$route.name].group;
    },
  },

  methods: {
    toggle() {
      if (!this.isActive) {
        this.$emit('update:expanded', this.name);
      } else {
        this.toggleOff();
      }
    },

    toggleOff() {
      if (!this.isActive) return;

      this.$emit('update:expanded', '_closed');

      this.$refs.link.focus();
    },
  },
};
</script>
